import { useState } from 'react';

import { USStateObject } from '../../constants/USstates/constants';
import { Button } from '../Clickables/Buttons/Button';
import { Container } from '../Container/Container';
import { Heading } from '../Heading/Heading';
import { ChevronDownIcon } from '../Icons/ChevronDownIcon';
import { ChevronUpIcon } from '../Icons/ChevronUpIcon';

import { StateLink } from './components/StateLink';

interface IProps {
  usStates: USStateObject[];
}

export const FindUSState = ({ usStates }: IProps) => {
  const [showMore, setShowMore] = useState<boolean>(false);

  return (
    <Container className="-px-6 sm:-px-11 md:-px-14">
      <div className="w-full bg-lake-fog">
        <div className="px-6 sm:px-11 md:px-14 md:py-8">
          <Heading variant="sm" as="h3" className="mb-2 pt-6">
            Fishing in your state
          </Heading>

          <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
            {usStates.map((state, index) => {
              return (
                <StateLink key={state.stateID} state={state} isHidden={index > 3 && !showMore} />
              );
            })}
          </div>

          {showMore ? (
            <div className="flex justify-center py-6">
              <Button
                variant="textPrimary"
                onClick={() => {
                  setShowMore(false);
                }}
              >
                Collapse full list
                <ChevronUpIcon />
              </Button>
            </div>
          ) : (
            <div className="flex justify-center py-6">
              <Button
                variant="textPrimary"
                onClick={() => {
                  setShowMore(true);
                }}
              >
                See all states
                <ChevronDownIcon />
              </Button>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};
